module.exports = __webpack_public_path__ + "img/tottenham.83efdd6b.png";